import Dialog from "../1. Core/Controls/Dialog/Dialog";

import Select from "../1. Core/Controls/Select/Select";
import TextField from "../1. Core/Controls/TextField/TextField";
import NP from "../1. Core/NP";
import {getStates} from "../10. Battle/Util";
import {ServerAPI} from "../1. Core/ServerAPI";
import Delegate from "../1. Core/Delegate";
import {Trainer} from "../10. Battle/types";
import ImageTextField from "../1. Core/Controls/TextField/ImageTextField";
import DateInput from "../1. Core/Controls/DateInput/DateInput";

let moment = require('moment');

export default class EditTrainerDialog extends Dialog {

	EvChanged: Delegate;
	_Trainer: Trainer;

	_firstNameField: TextField;
	_lastNameField: TextField;
	_qField: TextField;
	private regionCombo: Select;
	private _avatarContainer: HTMLElement;
	private _avatarImage: HTMLImageElement;
	private _photoURLInput: ImageTextField;
	private _sportClub: TextField;
	private _dateInput: DateInput;
	private _dateWorkInput: DateInput;
	private _achField: TextField;
	private _catField: TextField;


	_initFields(settings: object)
	{
		this.EvChanged = new Delegate();
		this._Trainer = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Trainer');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
	}

	_render()
	{
		super._render();


		this._avatarContainer = NP.createNode(this._contentNode, 'edit-athlete-dialog__avatar-container');
		this._avatarImage = NP.createNode(this._avatarContainer, 'edit-athlete-dialog__avatar', 'img');
		this._avatarImage.src = '/static/img/fake_avatar.svg'

		this._photoURLInput = new ImageTextField({
			ParentNode: this._contentNode,
			TextFieldSettings: {
				FloatingLabel: NP.RM.getString('PhotoUrl')
			},
			EvChanged: () => this.refreshAvatar()
		});


		this._firstNameField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('FirstName')
		});

		this._lastNameField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('LastName')
		});

		this._dateInput = new DateInput({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('DateBirth'),
			FontImage: NP.FontImages.event,
			EnabledEdit: false,
			Value: new Date()
		});

		this.regionCombo = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('State')
		});

		this._qField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Education')
		});

		this._achField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Achievements')
		});

		this._catField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Category')
		});

		this._sportClub = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('SportClub')
		});

		this._dateWorkInput = new DateInput({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('WorkStartDate'),
			FontImage: NP.FontImages.event,
			EnabledEdit: false,
			Value: new Date()
		});


		this._cancelButton.setIsVisible(false);


		this.refresh();


	}

	refreshAvatar()
	{
		if (this._photoURLInput.getValue())
		{
			this._avatarImage.src = this._photoURLInput.getValue()
			this._avatarImage.style.backgroundColor = "";
		}
		else
			this._avatarImage.style.backgroundColor = "#9E9E9E";
	}

	async refresh()
	{
		if (this._Trainer)
		{
			this._firstNameField.setValue(this._Trainer.FirstName);
			this._lastNameField.setValue(this._Trainer.LastName);
			this._qField.setValue(this._Trainer.Education);
			this.regionCombo.setValue(this._Trainer.RegionId);
			this._photoURLInput.setValue(this._Trainer.PhotoUrl)
			this._sportClub.setValue(this._Trainer.Club)

			this._achField.setValue(this._Trainer.Achievements)
			this._catField.setValue(this._Trainer.Category)

			if (this._Trainer.BirthDate)
				this._dateInput.setValue(moment(this._Trainer.BirthDate, 'YYYY-MM-DD').toDate())

			if (this._Trainer.WorkStartDate)
				this._dateWorkInput.setValue(moment(this._Trainer.WorkStartDate, 'YYYY-MM-DD').toDate())
		}
		this.refreshAvatar();

		let states = await getStates(3337)

		let items = states.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
		if (this.regionCombo)
		{
			this.regionCombo.setItems(items);

			if (this._Trainer)
				this.regionCombo.setValue(this._Trainer.RegionId);
		}
	}

	_onOkButtonClick()
	{
		ServerAPI.post(this._Trainer ? `/trainers/${this._Trainer.Id}` : "/trainers", {
			Id: this._Trainer && this._Trainer.Id,
			FirstName: this._firstNameField.getValue(),
			LastName: this._lastNameField.getValue(),
			Education: this._qField.getValue(),
			RegionId: this.regionCombo.getValue(),
			PhotoUrl: this._photoURLInput.getValue(),
			Club: this._sportClub.getValue(),
			BirthDate: this._dateInput.getValue() ? moment(this._dateInput.getValue()).format('YYYY-MM-DD') : null,
			WorkStartDate: this._dateWorkInput.getValue() ? moment(this._dateWorkInput.getValue()).format('YYYY-MM-DD') : null,
			Achievements: this._achField.getValue(),
			Category: this._catField.getValue(),
		}).then(() =>
		{
			this.EvChanged.fire(this);
			this.hide()
		});
	}
}